<!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

<!-- top -->
<template>
  <div>
    <template>
      <div class="text-center"></div>
    </template>
    <v-container style="width: 100%" id="recent-container" class="px-0">
      <v-card class="mb-3" v-if="lst_rep.length > 0">
        <v-card-text>
          <!-- report button -->
          <!-- @click="go_report" -->
          <!-- to="/report" -->
          <div class="d-flex flex-row justify-start align-start pt-0">
            <div style="width: 165px">
              <!-- add this back when doing tsep forms -->
              <!-- 'TSEP Form', -->
              <v-select
                attach
                class=""
                v-model="report_type"
                :items="['Print', 'Download CSV']"
                :rules="[(v) => !!v || 'Item is required']"
                label="Name/Type"
                required
              ></v-select>
            </div>
            <div class="">
              <v-btn
                @click="go_report"
                color="cmpbk"
                class="white--text px-1 ml-4"
                style="font-size: xx-small; position: relative; top: 13px"
                >Execute Report</v-btn
              >
            </div>
            <v-spacer></v-spacer>
            <div class="">
              <div
                style="
                  line-height: 1;
                  font-size: 1rem;
                  font-weight: 800;
                  position: relative;
                  top: 23px;
                  margin-left: 5px;
                "
              >
                <span class="showcountlbl">Count:</span>
                <span class="showcountlblsmll">Cnt:</span>
                {{ lst_search_results.length }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        style="width: 100%"
        :id="'srch' + rep.id"
        v-for="rep in lst_rep"
        :key="rep.id"
        class="mx-auto mb-2 recent-card"
      >
        <!--cards start-->
        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="col-md-12 pa-0 d-flex">
              <div class="font-weight-bold">Type:</div>
              <p class="mb-0 ml-2">
                {{ report_src }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Location:</div>
              <p class="mb-0 ml-2">
                {{ rep.location }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Mission Type:</div>
              <p class="mb-0 ml-2">
                {{ rep.mission_type }}
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Last modified:</div>
              <p class="mb-0 ml-2">
                {{ rep.s_date | shortDate }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">User:</div>
              <p class="mb-0 ml-2">
                {{ rep.s_user }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Reporting Officer:</div>
              <p class="mb-0 ml-2">
                {{ rep.reporting_officer }}
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Train Date:</div>
              <p class="mb-0 ml-2">
                {{ rep.trn_date | shortDate }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold mr-2">Case Number:</div>
              <p class="mb-0">
                {{ rep.case_num }}
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Outside Agency:</div>
              <p class="mb-0 ml-2">
                {{ rep.outside_agency_num }}
              </p>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">NFDD:</div>
              <p class="mb-0 ml-2">
                {{ rep.nfdd }}
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Shots Fired:</div>
              <p class="mb-0 ml-2">
                {{ rep.shots_fired }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-1"
            text
            @click="view_rep(report_src, rep.train_repId, rep.aft_act_repId)"
            >View/Edit</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  .hide-if-small {
    display: none !important;
  }
  .hide-if-large {
    display: flex;
  }
  .cnt_disp span {
    color: rgb(9, 9, 243);
  }
  .results-card {
    max-width: 344px;
  }

  .accident {
    font-size: smaller;
  }

  .showcountlblsmll {
    display: inline;
  }
  .showcountlbl {
    display: none;
  }
  /*   .accident .v-application--is-ltr::v-deep .v-chip .v-avatar--left {
    margin-right: 0 !important;
  } */
}

/* 768 media q */
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
  .results-card {
    max-width: 90%;
  }
  .showcountlblsmll {
    display: none;
  }
  .showcountlbl {
    display: inline;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "searchResults",
  mixins: [bus_common],
  props: ["lst_search_results", "update_search_results", "report_src"],

  data() {
    return {
      dialog: false,
      stat_data_map_view: {},
      update_map: null,
      map_view_dialog_visible: false,
      map_dialog_visible: false,
      report_type: "Print",
      lst_rep: [],
      group_size: 6,
      total_loaded: 0,
    };
  },
  watch: {
    update_search_results: {
      deep: true,
      handler() {
        this.show_loader(true);
        this.lst_rep = this.mno(this.lst_search_results);

        for (let index = 0; index < this.lst_rep.length; index++) {
          var rep = this.lst_rep[index];
          rep.s_date = this.$moment(rep.s_date).format("MM/DD/YYYY");
          rep.s_CreateDate = this.$moment(rep.s_CreateDate).format(
            "MM/DD/YYYY"
          );
          rep.trn_date = this.$moment(rep.trn_date).format("MM/DD/YYYY");
          if (rep.train_repId != null) {
            rep.id = rep.train_repId;
          }
          if (rep.aft_act_repId != null) {
            rep.id = rep.aft_act_repId;
          }
          console.log("rep.id: " + rep.id);
        }
        this.show_loader(false);
        //this.$moment(value, 'YYYY-MM-DD', true);
      },
      immediate: true,
    },
    lst_search_results: {
      deep: true,
      handler() {
        this.show_loader(true);
        this.lst_rep = this.mno(this.lst_search_results);

        for (let index = 0; index < this.lst_rep.length; index++) {
          var rep = this.lst_rep[index];
          rep.s_date = this.$moment(rep.s_date).format("MM/DD/YYYY");
          rep.s_CreateDate = this.$moment(rep.s_CreateDate).format(
            "MM/DD/YYYY"
          );
          rep.trn_date = this.$moment(rep.trn_date).format("MM/DD/YYYY");
          if (rep.train_repId != null) {
            rep.id = rep.train_repId;
          }
          if (rep.aft_act_repId != null) {
            rep.id = rep.aft_act_repId;
          }
          console.log("rep.id: " + rep.id);
        }
        this.show_loader(false);
        //this.$moment(value, 'YYYY-MM-DD', true);
      },
      immediate: true,
    },
  },
  computed: {
    is_admin: function () {
      if (this.$store.state.user.roles.indexOf("stat-admin") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    view_rep(repsrc, trainingid, aftactid) {
      console.log(repsrc, trainingid, aftactid);
      let token = this.$store.state.user.token;
      if (repsrc == "Training") {
        //go there
        this.$router.push({
          name: "trainingReport_add",
          params: { token: token, id: trainingid },
        });
      }
      if (repsrc == "After Action") {
        //go there
        console.log("afteractionReport_add " + token, aftactid);
        this.$router.push({
          name: "afteractionReport_add",
          params: { token: token, id: aftactid },
        });
      }
    },
    view(stat) {
      this.$emit("view", stat, document.documentElement.scrollTop);
    },
    delete_ask(stat) {
      var self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting an item created by '" + stat.s_user + "'. Continue?",
        "question",
        function () {
          self.delete_now(stat);
        },
        null,
        null,
        function () {}
      );
    },
    delete_now(stat) {
      this.$emit("delete_now", stat);
      var index = this.lst_rep.findIndex(
        (item) => item.stat_dataId === stat.stat_dataId
      );
      this.lst_rep.splice(index, 1);
    },

    remove_result(stat) {
      //this.mrbreakpoint("remove");
      var index = this.lst_search_results.findIndex(
        (item) => item.stat_data_cao_Id === stat.stat_data_cao_Id
      );
      this.lst_search_results.splice(index, 1);
    },
    edit(stat) {
      this.$emit("edit", stat);
    },
    go_report() {
      var ids = "";
      var arr_ids = [];
      if (this.report_src == "Training") {
        for (let index = 0; index < this.lst_search_results.length; index++) {
          const rep = this.lst_search_results[index];
          arr_ids.push(rep.train_repId);
        }
      } else {
        for (let index = 0; index < this.lst_search_results.length; index++) {
          const rep = this.lst_search_results[index];
          arr_ids.push(rep.aft_act_repId);
        }
      }
      ids = arr_ids.join("|");
      if (this.report_type == "Print" && this.report_src == "Training") {
        console.log("print train");
        window.open("/print/print_training_reports?ids=" + ids);
        return true;
      }
      if (this.report_type == "Print" && this.report_src == "After Action") {
        console.log("print aftact");
        window.open("/print/print_aftact_reports?ids=" + ids);
        return true;
      }
      //'Team Sum'
      if (this.report_type == "Team Sum") {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/print/teamsum/?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }
      //  'TSEP Form'
      if (this.report_type == "TSEP Form") {
        this.$router.push("/tsep_form");
      }
      //pie % contact
      if (this.report_type == "Pie: Contact %") {
        this.$router.push("/piechart");
      }
      //Pie: Stop Type %
      if (this.report_type == "Pie: Stop Type %") {
        this.$router.push("/pie_stop_type");
      }
      if (this.report_type == "Line: Count by Weeks") {
        this.$router.push("/line_cnt_by_weeks");
      }
      if (this.report_type == "Print by Week") {
        window.open("/print/byweek?frm_email=" + this.$store.state.user.email);
      }

      if (this.report_type == "Print by Month") {
        window.open("/print/bymonth?frm_email=" + this.$store.state.user.email);
      }

      if (this.report_type == "Download CSV" && this.report_src == "Training") {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/mvc_download_csv?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }
      if (
        this.report_type == "Download CSV" &&
        this.report_src == "After Action"
      ) {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/mvc_dl_aftact_csv?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }
      if (this.report_type == "Download CSV" && this.report_src == "Training") {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/mvc_download_csv?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }

      if (this.report_type == "Map") {
        this.update_map = new Date();
        this.map_dialog_visible = true;
      }

      return true;
    },
    // downloadFile(filePath) {
    //   var link = document.createElement("a");
    //   link.href = filePath;
    //   link.download = filePath.substr(filePath.lastIndexOf("/") + 1);
    //   link.click();
    // },
    init() {
      setTimeout(() => {
        this.show_loader(false);
      }, 200);
    },
  },
  mounted() {
    this.show_loader(true);
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
